import * as actions from '../actions/actionTypes';

const initialState = {
  vacations: [],
};

const updateVacationSuccess = (state, action) => {
  const size = action.vacations.data.splice(0, 1);
  const newVacation = state.vacations.map((vacation) => {
    for (let i = 0; i < size[0]; i++) {
      if (vacation.id === action.vacations.data[0][i].id) {
        return action.vacations.data[0][i];
      }
    }
    return vacation;
  });

  return { ...state, vacations: newVacation };
};

const createVacationSuccess = (state, action) => ({ ...state, vacations: state.vacations.concat(action.vacations) });

const deleteVacationSuccess = (state, action) => {
  const newVacation = state.vacations.filter(vacation => vacation.id !== action.id[0]);
  return {
    ...state,
    vacations: newVacation,
  };
};

const fetchVacationsSuccess = (state, action) => ({ ...state, vacations: action.vacations });


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.UPDATE_VACATION_SUCCESS: return updateVacationSuccess(state, action);
    case actions.CREATE_VACATION_SUCCESS: return createVacationSuccess(state, action);
    case actions.DELETE_VACATION_SUCCESS: return deleteVacationSuccess(state, action);
    case actions.FETCH_VACATIONS_SUCCESS: return fetchVacationsSuccess(state, action);

    default: return state;
  }
};

export default reducer;
